// extracted by mini-css-extract-plugin
export default {"container":"styles_container__p+gN1","image":"styles_image__UuBTS"};